<template lang="html">
  <div class="my-3 ml-n4 d-flex align-center" style="clear:both;">
    <div class="primary mr-5" style="width: 10px">
      <br>
    </div>
    <div class="text-h5 mr-3">
      <slot></slot>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name:"VSectionTitle"
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/varticle/VSectionTitle.vue